import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'
import { MenuItemLabel } from './MenuItemLabel'
import { MenuItemChevron } from './MenuItemChevron'
import { menuVariants } from '../variants/Menu.variants'

/**
 * Item de lista del menú (Nivel 2 y Nivel 3).
 * Renderiza un <button> con estados de focus, hover y selected.
 * @param {Object} props
 * @param {string} [props.id]
 * @param {boolean} [props.isSelected]
 * @param {boolean} [props.hasChildren]
 * @param {string} [props.className]
 * @param {string} [props.dataTestId]
 * @param {() => void} [props.onSelect]
 * @param {() => void} [props.onExpand]
 * @param {() => void} [props.onMouseEnter]
 * @param {boolean} [props.isExpanded]
 * @param {React.ReactNode} props.children
 */
export const MenuItem = ({
  id,
  isSelected = false,
  isExpanded,
  hasChildren = false,
  className,
  dataTestId,
  onSelect,
  onExpand,
  onMouseEnter,
  children,
}) => {
  const handleClick = () => {
    if (hasChildren) {
      onExpand?.()
    } else {
      onSelect?.()
    }
  }

  return (
    <button
      id={id}
      type="button"
      role="menuitem"
      data-testid={dataTestId}
      aria-haspopup={hasChildren ? 'menu' : undefined}
      aria-expanded={hasChildren ? (isExpanded ?? isSelected) : undefined}
      onMouseEnter={onMouseEnter}
      onClick={handleClick}
      className={cn(menuVariants.item({ isSelected }), className)}
    >
      <MenuItemLabel>{children}</MenuItemLabel>
      <MenuItemChevron hasChildren={hasChildren} />
    </button>
  )
}

MenuItem.displayName = 'MenuItem'

MenuItem.propTypes = {
  id: PropTypes.string,
  isSelected: PropTypes.bool,
  isExpanded: PropTypes.bool,
  hasChildren: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onSelect: PropTypes.func,
  onExpand: PropTypes.func,
  onMouseEnter: PropTypes.func,
  children: PropTypes.node,
}
